module.exports = __webpack_public_path__ + "static/making-a-good-brain-great-6215010eea89c817498486c19ae80142.jpg";